import { useOutletContext } from "react-router-dom";
import KnowledgeHub from "../../components/KnowledgeHub";

const KnowledgePage = () => {
  const { agent } = useOutletContext();

  return (
    <div className="h-full overflow-y-auto p-6">
      <KnowledgeHub agent={agent} />
    </div>
  );
};

export default KnowledgePage;
